import Title from 'components/Title'
import Paragraph from 'components/Paragraph'

import Styled from './styled'

export default function PolicyTechnician() {
  return (
    <Styled>
      <div className="container">
        <Title level={1}>นโยบายในการคัดกรองช่าง</Title>

        <div className="legal-container">
          <Paragraph className="text-p">
            บริษัท ทเวนตี้โฟร์ โซลูชั่น กรุ๊ป (ประเทศไทย) จำกัด (“บริษัทฯ”)
            จัดทำนโยบายในการคัดกรองช่างฉบับนี้ขึ้นเพื่อเป็นมาตรฐานในการเลือกสรรช่างและสร้างความเชื่อมั่นให้แก่ผู้ใช้บริการของบริษัทฯว่า
            ช่างที่บริษัทฯมอบหมายหน้าที่ในการให้บริการฯ แก่ผู้ใช้นั้น ล้วนเป็นผู้ที่มีความรู้
            ความสามารถ ความเชี่ยวชาญ และได้รับการตรวจสอบคุณสมบัติจากบริษัทฯเป็นอย่างดีแล้ว
          </Paragraph>

          <Paragraph className="text-p">
            โปรดทราบว่านโยบายในการคัดกรองช่างฉบับนี้อาจมีการเปลี่ยนแปลงได้
            โดยการเปลี่ยนแปลงทั้งหมดจะแสดงอยู่บนเว็บไซต์นี้
          </Paragraph>

          <Title className="text-title" medium level={4}>
            คุณสมบัติของช่าง
          </Title>

          <ol>
            <li>เป็นบุคคลสัญชาติไทย</li>
            <li>มีภูมิลำเนาเป็นหลักแหล่งแน่นอน และสามารถติดต่อได้เสมอ</li>
            <li>ประกอบอาชีพรับเหมาก่อสร้าง</li>
            <li>
              ต้องเป็นผู้ที่ผ่านการประเมินความรู้ความสามารถของกรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
            </li>
            <li>มีประสบการณ์การในงานรับเหมาก่อสร้างมากกว่า 1 ปี</li>
            <li>ผ่านการอบรมจากบริษัทฯ อย่างน้อย 1 ครั้ง</li>
            <li>สามารถติดต่อสื่อสารกับผู้ใช้บริการได้ดีและมีมนุษยสัมพันธ์ที่ดี</li>
            <li>มีสุขภาพแข็งแรง ไม่เป็นโรคที่เป็นอุปสรรคต่อการประกอบอาชีพ</li>
            <li>มีบุคลิกภาพที่สุภาพ อดทน ขยันหมั่นเพียร และซื่อสัตย์สุจริต</li>
            <li>มีความมั่นใจในตนเอง กล้าตัดสินใจ และสามารถแก้ไขปัญหาเฉพาะหน้าได้</li>
            <li>ไม่มีประวัติเกี่ยวข้องกับยาเสพติดและอาวุธร้ายแรง</li>
            <li>
              ไม่ใช่บุคคลที่ต้องคดีโทษความผิดทางอาญา หรือเคยรับโทษทางอาญาที่ร้ายแรง
              ยกเว้นความผิดฐานลหุโทษ
            </li>
            <li>ไม่เป็นบุคคลวิกลจริต ผู้ไร้ความสามารถ หรือผู้เสมือนไร้ความสามารถ</li>
          </ol>
        </div>
      </div>
    </Styled>
  )
}
